export default "__VITE_ASSET__B3A29_ID__"